import { DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MaintenanceService } from './maintenance.service';

@Component({
    selector: 'app-maintenance',
    standalone: true,
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    imports: [DatePipe, MatIconModule],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
    maintenanceService = inject(MaintenanceService);

    ngOnInit(): void {
        this.maintenanceService.startPolling();
        this.maintenanceService.startVisibilityCheck();
    }

    ngOnDestroy(): void {
        this.maintenanceService.stopPolling();
        this.maintenanceService.stopVisibilityCheck();
    }
}
